import SendTags from './SendTags'
export default SendTags
